import React, { FC, useEffect, useState } from 'react'
import t from 'src/translations/main'
import useFetch from 'src/components/Core/Hooks/useFetch/useFetch'
import useForm from 'src/components/Core/Hooks/useForm/useForm'
import utils from 'src/components/Organisms/Form/utils'
import config from './config'
import updateModal from 'src/components/Sections/Modal/updateModal'
import storage from 'src/components/Core/Utils/storage'
import { parseJson } from 'src/views/Pages/Onboarding/FormWrapper'
import { useCountryOfResidences, useCountryOfResidencesUpdate, useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

import Button from 'src/components/Atoms/Button/Button'
import Spinner from 'src/components/Core/Loading/Spinner/Spinner'
import Popup from 'src/components/Atoms/Popup/Popup'

import {
  FormStyle,
  FormFooter,
  FormFooterActionsRight,
} from 'src/components/Organisms/Form/Form.styles'

import { ApiData, TableObj } from 'src/views/Pages/Onboarding/types'
import { ModalCountryOfResidencyProps } from './types'

const ModalCountryOfResidency: FC<ModalCountryOfResidencyProps> = props => {
  const { actionType } = props
  const [serverValidationError, setServerValidationError] = useState('')
  const { isLoading, error, sendRequest } = useFetch()
  const tableData = useCountryOfResidences()
  const updateShareHoldersTableData = useCountryOfResidencesUpdate()
  const { dropdownOptions } = useDropdownOptions()

  const applicationId = storage.get(storage?.keys?.onboarding?.applicationId)

  const getFetchedData = () => {
    const rowData = [...tableData].filter(
      tableDataObj => tableDataObj.id === props.id
    )
    const reason1or2 = rowData[0].col3 === 'Reason B' ? '1' : '2'
    return utils.transformTableObj(
      { ...rowData[0], col1: (dropdownOptions?.countries?.find(country => country.label === rowData[0].col1))?.index?.toString(),
        col3: rowData[0].col3 === 'Reason A' ? '0' : reason1or2
      },
      props.tableConfig
    )
  }

  const fetchedData = actionType === 'add' ? {} : getFetchedData()

  const submitForm = (submitData: ApiData) => {
    if (actionType === 'edit') submitData.data.id = fetchedData.id
    submitData.data.applicationId = applicationId
    // eslint-disable-next-line
    const modifyResponse = (data: any) => {
      const serverValidationErrorsParsed = parseJson(data?.reasonPhrase)
      if(serverValidationErrorsParsed && serverValidationErrorsParsed[0].key === 'generalError') {
        setServerValidationError(t(`onboarding.errors.${serverValidationErrorsParsed[0].errorcode}`) || serverValidationErrorsParsed[0].errordescription?.split(':')[1] || t('error.invalidValue'))
        return
      }
      if(Array.isArray(serverValidationErrorsParsed) && serverValidationErrorsParsed.length > 0) {
        submitData.setConfigData(utils.injectErrorPropToConfig(submitData.configData, [], serverValidationErrorsParsed))
        return
      }

      if (data) {
        updateModal({ modalState: 'close' })
        const reasonBC = submitData.data.reason === '1' ? 'B' : 'C'
        if (actionType === 'add') {
          submitData.data.id = data
          updateShareHoldersTableData((prevState: TableObj[]) => {
            return utils.addRowToTableData(
              [...prevState],
              {
                ...submitData.data,
                country: dropdownOptions?.countries?.find(country => country?.index.toString() === submitData?.data?.country)?.label,
                reason: submitData.data.isTINAvailable === 'true' ? '' : `Reason ${submitData?.data.reason === '' ? 'A' : reasonBC}`
              },
              props.tableConfig,
              props.action
            )
          })
        }
        if (actionType === 'edit') {
          updateShareHoldersTableData((prevState: TableObj[]) => {

            return utils.getEditedTableData(
              [...prevState],
              {
                ...submitData.data,
                country: dropdownOptions?.countries?.find(country => country?.index.toString() === submitData?.data?.country)?.label,
                reason: submitData.data.isTINAvailable === 'true' ? '' :  `Reason ${submitData?.data.reason === '0' ? 'A' : reasonBC}`
              },
              props.tableConfig,
              props.action
            )
          })
        }
      }
    }
    sendRequest(
      {
        scope: 'onboarding',
        url: props.postUrl,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: submitData.data,
      },
      modifyResponse
    )
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    toggleShowByVisualName,
    configData
  } = useForm(
    fetchedData,
    config({ countries: dropdownOptions.countries }),
    submitForm
  )

  useEffect(() => {
    toggleShowByName(
      'reasonForNotObtainTIN',
      formData?.reason?.value === '1'
    )
  }, [formData?.reason?.value])

  useEffect(() => {
    toggleShowByName(
      'tin',
      formData?.isTINAvailable?.value === 'true'
    )
    toggleShowByName(
      'reason',
      formData?.isTINAvailable?.value === 'false'
    )
    toggleShowByVisualName('ifTINavailableText',
      formData?.isTINAvailable?.value === 'false' ? 'true' : 'false'
    )

  }, [formData?.isTINAvailable?.value])

  if (isLoading) return <Spinner removeFullscreen />

  if (error) return <p>{error?.message || error}</p>

  return (
    <FormStyle onSubmit={handleSubmit}>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter insideModal>
        <FormFooterActionsRight>
          <Button
            version={2}
            label={t('onboarding.main.cancelButton')}
            onClick={() => updateModal({ modalState: 'close' })}
          />
          <Button
            type='submit'
            label={t('onboarding.main.saveButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
      {!isLoading && (error || serverValidationError) && <Popup type='error' label={error || serverValidationError} popupContainerWidth='auto' popupContainerHeight='auto'/>}
    </FormStyle>
  )
}

export default ModalCountryOfResidency
